import * as React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";

import List from "@mui/material/List";
import { DoctorHolidaysTable } from "./doctorHolidayTable";
import { FormControl, TextField } from "@mui/material";
import moment from "moment";
import { createOrUpdateDoctorDetails } from "../Helper/API";
import { getProviderArray, getUserDetails, groupHolidaysByMonth } from "../Helper/utils";
import { ToastEmitter } from "../ToastEmitter";
import { months } from "../constant";
import { logEventToAnalyticsPlatform, fetchUserDetailsAndSetUserForAnalytics } from "../../../helper/events"
import { EVENTS } from "../events_Constant"

const style = {
  py: 0,
  width: "100%",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
};

export const DoctorHolidays = ({ doctorProfileDetails }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const doctorId = queryParams.get("drId");
  const [monthlyHolidays, setMonthlyHolidays] = useState();
  const [holidayList, setHolidayList] = useState();
  const next6Months = [];
  const today = new Date();
  const currentMonth = today.getMonth();
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  for (let i = 0; i <= 5; i++) {
    const nextMonthIndex = (currentMonth + i) % 12;
    next6Months.push(months[nextMonthIndex]);
  }

  useEffect(() => {
    setHolidayList(doctorProfileDetails?.doctors[0].holidays);
  }, []);

  useEffect(()=>{
    const triggerEvents = async ()=>{
      await fetchUserDetailsAndSetUserForAnalytics();
    logEventToAnalyticsPlatform({
      name: EVENTS.PC_SCREEN_LANDING.name,
      payload: {
        tab_name: EVENTS.TAB_NAME_ADD_EDIT_HOLIDAYS,
        service_type: EVENTS.SERVICE_TYPE_OFFLINE_CONSULTS,
        screenName: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
      },
      schema: EVENTS.PC_SCREEN_LANDING.schema,
    })
    }
    triggerEvents();
   
  },[])

  useEffect(() => {
    setGroupedHolidaysByMonth();
  }, [holidayList]);

  function setGroupedHolidaysByMonth() {
    const groupedHolidays = groupHolidaysByMonth(holidayList);
    setMonthlyHolidays(groupedHolidays);
  }

  function removeHoliday(range) {
    let holidayListTemp = [...holidayList];
    for (let i = 0; i < range.length; i++) {
      const holidays = holidayListTemp.filter((holiday) => holiday.date == range[i].date);
      for (const holiday of holidays) {
        if (holiday.id) {
          holiday.isActive = false;
        } else {
          holidayListTemp = holidayListTemp.filter((holiday) => holiday.date != range[i].date);
        }
      }
    }
    setHolidayList(holidayListTemp);
  }

  function addHoliday(startDate, endDate) {
    if (startDate > endDate) {
      ToastEmitter("Start date cannot be greater than end date", "error");
      setShowError(true);
      setError("Start date cannot be greater than end date");
      setStartDate("");
      setEndDate("");
      return;
    }
    let curr = moment(startDate);
    let next = moment(endDate);
    if (next.diff(curr, "days") > 30) {
      ToastEmitter("Cannot add more than 30 days", "error");
      setShowError(true);
      setError("Cannot add more than 30 days");
      setStartDate("");
      setEndDate("");
      return;
    }
    setShowError(false);
    let holidayListTemp = [...holidayList];
    while (curr.format("YYYY-MM-DD") <= next.format("YYYY-MM-DD")) {
      const index = holidayListTemp.findIndex((holiday) => holiday.date == curr.format("YYYY-MM-DD"));
      if (index == -1) {
        holidayListTemp.push({ date: curr.format("YYYY-MM-DD") });
      } else {
        holidayListTemp[index].isActive = true;
      }
      curr = curr.add(1, "day");
    }
    setHolidayList(holidayListTemp);
    setStartDate("");
    setEndDate("");
  }

  async function saveHolidays() {
    const userDetails = getUserDetails();
    holidayList.map((holiday) => {
      holiday.updatedBy = userDetails.userId;
    });
    const providerArray = getProviderArray();
    const data = {
      providerIds: providerArray,
      doctors: [
        {
          doctorId: parseInt(doctorId),
          holidays: holidayList,
        },
      ],
    };
    const response = await createOrUpdateDoctorDetails(data);
    const updatedProfileDetails = doctorProfileDetails.doctors[0]
    if (response.success) {
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_LS_ACTION.name,
        payload: {
            tab_name: EVENTS.TAB_NAME.ADD_HOLIDAYS,
            filterValue: '',
            reference_id: ""+updatedProfileDetails?.doctorId||'',
            reference_provider_id: ""+updatedProfileDetails?.providerId || '',
            reference_provider_name:updatedProfileDetails?.providerName || '',
            service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
            action: EVENTS.ACTION.HOLIDAYS_CREATED,
        },
        schema: EVENTS.PC_LS_ACTION.schema,
    })
      history.push("/offlineConsults/DoctorManagement");
    } else {
      ToastEmitter("Something went wrong Please Try Again", "error");
    }
  }

  return (
    <List sx={style} className="w-[80vw]">
      <div style={{ margin: "20px" }}>
        <div className="flex date-filter-dashboard">
          <FormControl style={{ minWidth: "200px" }}>
            <label className="mb-1 text-sm font-normal text-gray-700" id={"startDate"}>
              {"Start Date"}
            </label>
            <TextField
              className="w-full"
              id="date"
              type="date"
              value={startDate ? startDate : ""}
              inputProps={{
                min: moment().format("YYYY-MM-DD"),
                max: moment().add(6, "months").format("YYYY-MM-DD"),
              }}
              onChange={(evt) => setStartDate(evt.target.value)}
            />
          </FormControl>
          <FormControl style={{ marginLeft: "10px", minWidth: "200px" }}>
            <label className="mb-1 text-sm font-normal text-gray-700" id={"endDate"}>
              {"End Date"}
            </label>
            <TextField
              className="w-full"
              id="date"
              type="date"
              value={endDate ? endDate : ""}
              inputProps={{
                min: moment().format("YYYY-MM-DD"),
                max: moment().add(6, "months").format("YYYY-MM-DD"),
              }}
              onChange={(evt) => setEndDate(evt.target.value)}
            />
          </FormControl>
          <div className="flex justify-center items-end ml-2">
            <button
              className={`flex items-center justify-center h-10 p-3 border rounded-lg text-sm text-semibold ${
                !startDate || !endDate ? "bg-gray-100 border-gray-300 text-gray-400" : "border-blue-500 text-blue-700"
              }`}
              disabled={!startDate || !endDate}
              onClick={() => addHoliday(startDate, endDate)}
            >
              Add Holiday
            </button>
          </div>
        </div>
        {showError && <div className="text-red-500 text-xs mb-5">{error}</div>}
      </div>
      <DoctorHolidaysTable
        next6Months={next6Months}
        monthlyHolidays={monthlyHolidays}
        setMonthlyHolidays={setMonthlyHolidays}
        removeHoliday={removeHoliday}
      ></DoctorHolidaysTable>
      <div className="flex justify-end my-3 mr-3">
        <button
          className="flex items-center justify-center h-10 p-3 border rounded-lg text-sm text-semibold border-gray-300 mr-3"
          style={{ width: "80px" }}
          onClick={() => history.push("/offlineConsults/DoctorManagement")}
        >
          Close
        </button>
        <button
          className="flex items-center justify-center h-10 p-3 border rounded-lg text-sm text-semibold bg-blue-600 border-blue-700 text-white"
          style={{ width: "80px" }}
          onClick={() => saveHolidays()}
        >
          Save
        </button>
      </div>
    </List>
  );
};
